import { render, staticRenderFns } from "./DrawerTicket.vue?vue&type=template&id=5684dbda&scoped=true&"
import script from "./DrawerTicket.vue?vue&type=script&lang=js&"
export * from "./DrawerTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5684dbda",
  null
  
)

export default component.exports